<template>
    <div class="pt-4 tb-4">
        <div class="display-1 mb-4">Оценка навыка работы в цифровой среде</div>

        <v-layout>
            <v-flex xs12 class="mr-4" v-html="result"></v-flex>
            <v-flex v-if="!hideChart">
                <charts-pie :value="value" :max="500" :level="level"></charts-pie>
            </v-flex>
        </v-layout>
    </div>
</template>
<script>
    import data from './data'
    import ChartsPie from '@/components/charts/pie'

    export default {
        props: {
            value: Number,
            hideChart: Boolean
        },
        components: {
            ChartsPie
        },
        computed: {
            level () {
                if (this.value > 336) {
                    return 5
                } else if (this.value > 168) {
                    return 3
                } else {
                    return 1
                }
            },
            result () {
                return data['level' + this.level]
            }
        }
    }
</script>
